/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2022-07-28 10:40:57
 * @FilePath: \frontend\src\utils\get-page-title.js
 */
// import defaultSettings from '@/settings';
import { i18n } from '@/Lang/index';

// const title = defaultSettings.title;
const title = i18n.global.t('constLang.title');

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}
